import { Box } from "@chakra-ui/react";
import { ErrorPage, getTrackingId } from "@euka-mfes/bark";
import { LearningClassEnums as CLS } from "@/ts/enums/LearningClassEnums";
import { useNavigate } from "react-router-dom";
import { clearServerError } from "@/api/httpClient";
import { getHomeRoute } from "@/utils/route";
import { useStudentData } from "@/context";

const ServerErrorContainer: React.FC = () => {
  const navigate = useNavigate();
  const { selectedGrade } = useStudentData();

  const handlePrimaryClick = () => {
    // Clear the error flag so the app re-renders normally, then navigate
    // to the dashboard. No hard redirect needed — the flag reset is
    // enough to make ThemedLayout switch back to <Outlet />.
    clearServerError();
    navigate(getHomeRoute(selectedGrade?.grade_code as number));
  };

  const handleReload = () => {
    window.location.reload();
  };

  return (
    <Box
      data-tracking-id={getTrackingId(
        [CLS.ServerErrorContainer, CLS.Button],
        "container"
      )}
    >
      <ErrorPage
        statusCode={500}
        statusTitle="Technical Turbulence: 500 error"
        statusDescription="Oops! Something went wrong on our end. Our team is
                              on it, working to fix the issue. Please bear with us
                              and try again shortly. We apologise for any
                              inconvenience."
        btnPrimaryText="Reload Page"
        onClickBtnPrimary={handleReload}
        btnSecondaryText="Return to dashboard"
        onClickBtnSecondary={handlePrimaryClick}
      />
    </Box>
  );
};

export default ServerErrorContainer;
